"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PackAction = /** @class */ (function () {
    function PackAction(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
    PackAction.None = new PackAction("", "None");
    PackAction.Verify = new PackAction("Verify", "Verify");
    PackAction.Supply = new PackAction("Supply", "Supply");
    PackAction.MarkAsLocked = new PackAction("MarkAsLocked", "Mark as locked");
    PackAction.ExportFromEU = new PackAction("ExportFromEU", "Export from EU");
    PackAction.MarkAsSample = new PackAction("MarkAsSample", "Mark as sample");
    PackAction.MarkAsFreeSample = new PackAction("MarkAsFreeSample", "Mark as free sample");
    PackAction.MarkAsStolen = new PackAction("MarkAsStolen", "Mark as stolen");
    PackAction.MarkAsDestroyed = new PackAction("MarkAsDestroyed", "Mark as destroyed");
    PackAction.Reintroduce = new PackAction("Reintroduce", "Reintroduce");
    PackAction.Reactivate = new PackAction("Reactivate", "Reactivate");
    PackAction.UndoMarkAsLocked = new PackAction("UndoMarkAsLocked", "Undo mark as locked");
    PackAction.UndoExportFromEU = new PackAction("UndoExportFromEU", "Undo export from EU");
    PackAction.UndoMarkAsSample = new PackAction("UndoMarkAsSample", "Undo mark as sample");
    PackAction.UndoMarkAsFreeSample = new PackAction("UndoMarkAsFreeSample", "Undo mark as free sample");
    PackAction.UndoMarkAsStolen = new PackAction("UndoMarkAsStolen", "Undo mark as stolen");
    PackAction.UndoMarkAsDestroyed = new PackAction("UndoMarkAsDestroyed", "Undo mark as destroyed");
    PackAction.parse = function (packActionValue) {
        switch (packActionValue) {
            case PackAction.Verify.value:
                return PackAction.Verify;
            case PackAction.Supply.value:
                return PackAction.Supply;
            case PackAction.MarkAsLocked.value:
                return PackAction.MarkAsLocked;
            case PackAction.ExportFromEU.value:
                return PackAction.ExportFromEU;
            case PackAction.MarkAsSample.value:
                return PackAction.MarkAsSample;
            case PackAction.MarkAsFreeSample.value:
                return PackAction.MarkAsFreeSample;
            case PackAction.MarkAsStolen.value:
                return PackAction.MarkAsStolen;
            case PackAction.MarkAsDestroyed.value:
                return PackAction.MarkAsDestroyed;
            case PackAction.Reintroduce.value:
                return PackAction.Reintroduce;
            case PackAction.UndoMarkAsLocked.value:
                return PackAction.UndoMarkAsLocked;
            case PackAction.UndoExportFromEU.value:
                return PackAction.UndoExportFromEU;
            case PackAction.UndoMarkAsSample.value:
                return PackAction.UndoMarkAsSample;
            case PackAction.UndoMarkAsFreeSample.value:
                return PackAction.UndoMarkAsFreeSample;
            case PackAction.UndoMarkAsStolen.value:
                return PackAction.UndoMarkAsStolen;
            case PackAction.UndoMarkAsDestroyed.value:
                return PackAction.UndoMarkAsDestroyed;
            case PackAction.Reactivate.value:
                return PackAction.Reactivate;
            default:
                console.error("Could not parse pack action value: " + packActionValue);
            case PackAction.None.value:
                return PackAction.None;
        }
    };
    return PackAction;
}());
exports.PackAction = PackAction;
//# sourceMappingURL=PackAction.js.map